var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-section-profile-settings"},[_c('div',[_c('h4',{staticClass:"profile-section--header"},[_vm._v(" "+_vm._s(_vm.$t('settings.profile.display.title'))+" ")]),_c('div',{staticClass:"bc-form-grid"},[_c('ProfileDisplaySetting')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }